import { createAsyncThunk } from '@reduxjs/toolkit';

import { ROLES } from '../../constants/role';

import { UserService } from '../../services';

export const createUserDashboardPreferences = createAsyncThunk(
  'userSlice/createUserDashboardPreferences',
  async (data, { rejectWithValue }) => {
    try {
      const response = await UserService.createUserDashboardPreferences(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create dashboard preferences');
    }
  }
);

export const fetchUser = createAsyncThunk('userSlice/fetchUser', async (_, { rejectWithValue }) => {
  try {
    const { data } = await UserService.getUser();

    return {
      user: data,
      permissions: (data?.roles || []).flatMap(role => role.permissions.map(({ name }) => name)),
      isAdmin: !!data?.roles?.find(r => r.name === ROLES.ADMIN.value)
    };
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch user');
  }
});

export const fetchUserDashboardPreferences = createAsyncThunk(
  'userSlice/fetchUserDashboardPreferences',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await UserService.fetchDashboardPreferences();

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard preferences');
    }
  }
);

export const fetchUserTableSettings = createAsyncThunk(
  'userSlice/fetchUserTableSettings',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await UserService.fetchUserTableSettings();

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch user table settings');
    }
  }
);

export const upsertTablePageSize = createAsyncThunk(
  'userSlice/upsertTablePageSize',
  async (data, { rejectWithValue }) => {
    try {
      const response = await UserService.upsertTablePageSize(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to upsert user table settings');
    }
  }
);

export const confirmRoles = createAsyncThunk('userSlice/confirmRoles', async (ids, { rejectWithValue }) => {
  try {
    const response = await UserService.confirmRoles(ids);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to confirm role');
  }
});

export const deleteUserDashboardPreferences = createAsyncThunk(
  'userSlice/deleteUserDashboardPreferences',
  async (_, { rejectWithValue }) => {
    try {
      const response = await UserService.deleteUserDashboardPreferences();

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to reset dashboard preferences');
    }
  }
);
